import { createSlice } from '@reduxjs/toolkit';
import { IDevice, IDeviceResponse } from '../../service/deviceListService';
import { revertAll } from '../actions';

export interface IDeviceState {
    deviceList: IDevice[];
    deviceData: IDeviceResponse | null;
}

const initialState: IDeviceState = {
    deviceList: [],
    deviceData: null,
};

const devicesSlice = createSlice({
    name: 'devices',
    initialState,
    reducers: {
        updateDeviceListState: (state, action) => {
            const { payload } = action ?? {};
            if (Array.isArray(payload)) {
                const map = new Map([...payload].map(item => [item.device_id, item]));
                const combinedUnique = Array.from(map.values())?.sort((a, b) => a.device_id.localeCompare(b.device_id));

                return {
                    ...state,
                    deviceList: combinedUnique,
                };
            }

            return {
                ...state,
                deviceList: state.deviceList,
            };
        },
        updateDeviceDataState: (state, action) => {
            const { payload } = action ?? {};
            return {
                ...state,
                deviceData: payload,
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const { updateDeviceListState, updateDeviceDataState } = devicesSlice.actions;

export const devicesReducer = devicesSlice.reducer;
